import { Empty, Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import type { AtRiskRow } from '../contract';
import { creatorName, fmtKc } from '../format';
import { rowOpenProps } from './row-open';
import styles from '../style.module.scss';

interface Props {
  rows: AtRiskRow[];
  onSelect?: (uid: string) => void;
}

/** "Sắp lỡ mốc": Creator cần nhiều ngày LIVE hợp lệ hơn số ngày còn lại của tháng. */
const AtRiskList = ({ rows, onSelect }: Props) => {
  const columns: ColumnsType<AtRiskRow> = [
    {
      title: 'Creator',
      key: 'creator',
      render: (_, r) => (
        <div className={styles.cellCreator}>
          <span className={styles.cellName}>{creatorName(r)}</span>
          {r.groupName && <span className={styles.cellGroup}>{r.groupName}</span>}
        </div>
      ),
    },
    {
      title: 'Bậc',
      dataIndex: 'level',
      width: 56,
      align: 'center',
      render: (v: number | null) => (v ? v : '—'),
    },
    {
      title: 'Ngày cần / còn',
      key: 'days',
      width: 110,
      align: 'right',
      render: (_, r) => (
        <span>
          <strong className={styles.textDown}>{r.needDays}</strong> / {r.daysRemaining}
        </span>
      ),
    },
    {
      title: 'Thiếu KC',
      dataIndex: 'needKc',
      width: 100,
      align: 'right',
      render: (v: number) => fmtKc(v),
    },
  ];

  return (
    <section className={styles.card} aria-label="Sắp lỡ mốc">
      <h2 className={styles.cardTitle}>Sắp lỡ mốc</h2>
      {rows.length === 0 ? (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description="Không có Creator nào thiếu ngày LIVE so với số ngày còn lại."
        />
      ) : (
        <Table<AtRiskRow>
          size="small"
          rowKey="uid"
          columns={columns}
          dataSource={rows}
          pagination={false}
          scroll={{ x: 380 }}
          rowClassName={() => (onSelect ? styles.clickRow : '')}
          onRow={(r) =>
            onSelect ? rowOpenProps(`Xem chi tiết ${creatorName(r)}`, () => onSelect(r.uid)) : {}
          }
        />
      )}
    </section>
  );
};

export default AtRiskList;
